import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {forkJoin} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {ReferentialService} from '../../../services/referential/referential.service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-device-type-selector',
  templateUrl: './device-type-selector.component.html',
  styleUrls: ['./device-type-selector.component.css']
})
export class DeviceTypeSelectorComponent implements OnInit {

  public deviceTypesForChipFilter;
  public deviceTypeList: MatTableDataSource<any>;
  public deviceTypeListColumns: string[] = ['name', 'description'];
  public pageSizeOptions = environment.pageSizeOptions;
  public deviceTypes;
  public showSpinner: boolean;
  public filter: string = '';
  public otherDevicesType: boolean = false;
  public projectDeviceLocationModeExcludedTypes: number[] = [8, 9, 10, 11, 12, 17, 18, 19];

  @Input('deviceTypeFilterForChips') deviceTypeFilterForChips: number[] = [];
  @Input('projectDeviceLocationMode') projectDeviceLocationMode: boolean = false;
  @Input('deviceTypeSelected') deviceTypeSelected: number = 0;
  @Input('widthInPercent') widthInPercent: number = 100;
  @Output('deviceTypeChanged') deviceTypeChanged = new EventEmitter<number>();

  @ViewChild(MatSort) sortDeviceTypes: MatSort;
  @ViewChild(MatPaginator) paginatorDeviceTypes: MatPaginator;


  constructor(private referentialService: ReferentialService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.showSpinner = true;
    this.referentialService.getDeviceTypes().pipe(map((data: any) => {
        data.forEach((d) => {
          d.value = d.id;
          delete d.id;
          d.name = d.type;
          d.description = this.translate.instant(d.type + '_LONG_DESC');
          delete d.type;
        });
        return data;
      })
    ).subscribe((results) => {
      this.deviceTypes = results;
      this.initList();
      this.showSpinner = false;
    }, error => {
      this.showSpinner = false;
    });
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.deviceTypeList.filter = filterValue;
  }

  filterList(type: number) {
    if (this.deviceTypeSelected !== type) {
      this.deviceTypeSelected = type;
    } else {
      this.deviceTypeSelected = 0;
    }
    this.deviceTypeChanged.emit(this.deviceTypeSelected);
  }

  getSelectedDeviceTypeNameForOtherDevices() {
    if (!this.showSpinner) {
      let dtFiltered = this.deviceTypes.filter(dt => dt.value == this.deviceTypeSelected && dt.value >= 1000);
      return dtFiltered;
    } else {
      return [];
    }

  }

  private initList() {
    this.otherDevicesType = this.deviceTypes.filter(dts => dts.value >= 1000).length > 0;
    this.deviceTypesForChipFilter = this.deviceTypes.filter(dts => dts.value < 1000);
    if (this.deviceTypeFilterForChips.length > 0) {
      this.deviceTypesForChipFilter = this.deviceTypesForChipFilter.filter(dts => this.deviceTypeFilterForChips.includes(dts.value));
    }
    if (this.projectDeviceLocationMode) {
      this.deviceTypesForChipFilter = this.deviceTypesForChipFilter.filter(dts => !this.projectDeviceLocationModeExcludedTypes.includes(dts.value));
    } else {
      this.deviceTypeList = new MatTableDataSource(this.deviceTypes.filter(dts => dts.value >= 1000));
      this.deviceTypeList.sort = this.sortDeviceTypes;
      this.deviceTypeList.paginator = this.paginatorDeviceTypes;
      this.deviceTypeList.paginator.firstPage();
    }
  }


}
